import { render, staticRenderFns } from "./SupportLogin.vue?vue&type=template&id=57adab50&scoped=true&"
import script from "./SupportLogin.vue?vue&type=script&lang=js&"
export * from "./SupportLogin.vue?vue&type=script&lang=js&"
import style0 from "./SupportLogin.vue?vue&type=style&index=0&id=57adab50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57adab50",
  null
  
)

export default component.exports